export interface SheetElements {
  content: HTMLElement;
  contentHeight: number;
}

export const getClientY = (event: TouchEvent | MouseEvent): number => {
  if ('touches' in event) {
    return event.touches[0]?.clientY ?? event.changedTouches[0]?.clientY ?? 0;
  }
  return event.clientY;
};

export const getSheetElements = (content: HTMLElement): SheetElements => {
  const sheet = (content.closest('.pano-modal__content') as HTMLElement) ?? content;

  return {
    content: sheet,
    contentHeight: sheet.offsetHeight,
  };
};

export const freezeTransitions = ({ content }: SheetElements): void => {
  content.style.transition = 'none';
};

export const applyDrag = ({ content }: SheetElements, deltaY: number): void => {
  content.style.transform = `translateY(${deltaY}px)`;
};

export const releaseTransitions = ({ content }: SheetElements): void => {
  content.style.transition = '';
};

export const resetDrag = ({ content }: SheetElements): void => {
  content.style.transform = '';
};

export interface ShouldCloseArgs {
  dragY: number;
  durationMs: number;
  contentHeight: number;
  closeThreshold: number;
}

export const shouldClose = ({
  dragY,
  durationMs,
  contentHeight,
  closeThreshold,
}: ShouldCloseArgs): boolean => {
  const velocity = durationMs > 0 ? dragY / durationMs : 0;
  return dragY > contentHeight * closeThreshold || (dragY > 50 && velocity > 0.5);
};

export const isInteractiveTarget = (target: EventTarget | null): boolean =>
  target instanceof Element && !!target.closest('button, input, a');
